import ACCESS from 'utils/Access'

const routingTitle = !ACCESS.hasFeature('rules_routing') ? 'Conversation Routing' : 'Basic Conversation Routing'

export const PAGE_TITLES = [
  { path: '/settings/notifications', title: 'Notifications' },
  { path: '/settings/profile', title: 'Drift Profile' },
  { path: '/settings/email', title: 'Email' },
  { path: '/settings/assistant', title: 'Drift Assistant' },
  { path: '/settings2/conversations', title: 'Conversations' },
  { path: '/settings/rules', title: routingTitle },
  { path: '/settings2/teams', title: 'Teams' },
]



// WEBPACK FOOTER //
// ./src/scripts/components/settings/constants.js